namespace GeniuzPOS.Product {
    export interface CsStyleRow {
        Id?: number;
        StyleId?: string;
        StyleName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsStyleRow {
        export const idProperty = 'StyleId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsStyle';
        export const lookupKey = 'Product.CsStyle';

        export function getLookup(): Q.Lookup<CsStyleRow> {
            return Q.getLookup<CsStyleRow>('Product.CsStyle');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:แบบ:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:แบบ:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:แบบ:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:แบบ:Modify';

        export declare const enum Fields {
            Id = "Id",
            StyleId = "StyleId",
            StyleName = "StyleName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
